import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Info } from 'react-feather';

const InfoPopover = ({ headerContent, bodyContent, placement = 'right', iconMargin }) => {
  iconMargin = iconMargin != null ? iconMargin : 2;
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <OverlayTrigger
      trigger={['hover','focus','click']}
      key='info-popover'
      placement={screenSize < 768 ? 'bottom' : placement}
      overlay={
        <Popover className={'infoButton rounded-4 border-0 shadow'}>
          <Popover.Header className={'border-0 pb-0 text-dark-blue'}>{headerContent}</Popover.Header>
          <Popover.Body>{bodyContent}</Popover.Body>
        </Popover>
      }>
      <Info className={`text-white ms-${iconMargin} bg-primary rounded-circle`} width={18} height={18} strokeWidth={2} />
    </OverlayTrigger>
  );
};

export default InfoPopover;
